import {
  __name,
  init_react_import
} from "./chunk-65BGW52G.mjs";

// ../lib/hooks/useToggle.ts
init_react_import();
import { useCallback, useState } from "react";
function useToggle_default(initialValue = false) {
  const [value, setValue] = useState(!!initialValue);
  const set = useCallback((newValue) => setValue(newValue), []);
  const toggle = useCallback(() => setValue(!value), [
    value
  ]);
  const enable = useCallback(() => setValue(true), []);
  const disable = useCallback(() => setValue(false), []);
  return [
    value,
    {
      set,
      toggle,
      enable,
      disable
    }
  ];
}
__name(useToggle_default, "default");

export {
  useToggle_default
};
//# sourceMappingURL=chunk-CRERXMKA.mjs.map